const comparatorData = [
    '>',
    '<',
    '='
]

export default comparatorData